import type { SubmissionAction } from '../../hooks/use-pack-submissions.js';

/* Variant por ação: primária p/ avançar (start-review/approve/reopen), outline p/ mudanças,
   ghost p/ rejeitar (destrutiva discreta). */
export function actionVariant(action: SubmissionAction): 'default' | 'outline' | 'ghost' {
  if (action === 'request-changes') return 'outline';
  if (action === 'reject') return 'ghost';
  return 'default';
}

/* Config das ações de moderação que abrem o ReasonDialog. Compartilhada entre a lista
   (linha da fila) e o detalhe (ADR-0462) — fonte única, sem duplicar o mapa. `start-review`
   e `reopen` NÃO abrem diálogo (sem motivo) → disparam direto no clique. */
export type DialogAction = Exclude<SubmissionAction, 'start-review' | 'reopen'>;

interface ActionConfig {
  readonly title: string;
  readonly description: string;
  readonly confirmLabel: string;
  readonly reasonLabel: string;
  readonly destructive: boolean;
  readonly validate: (reason: string) => boolean;
}

export const ACTION_CONFIG: Readonly<Record<DialogAction, ActionConfig>> = {
  approve: {
    title: 'Aprovar submissão',
    description: 'Notas são opcionais. A publicação é promovida automaticamente ao aprovar.',
    confirmLabel: 'Aprovar',
    reasonLabel: 'Notas (opcional)',
    destructive: false,
    validate: () => true,
  },
  'request-changes': {
    title: 'Pedir mudanças',
    description: 'Explique o que o publisher precisa ajustar antes de reenviar.',
    confirmLabel: 'Pedir mudanças',
    reasonLabel: 'Motivo',
    destructive: false,
    validate: (reason) => reason.trim().length > 0,
  },
  reject: {
    title: 'Rejeitar submissão',
    description: 'Explique o motivo da rejeição — o publisher vê esta mensagem.',
    confirmLabel: 'Rejeitar',
    reasonLabel: 'Motivo',
    destructive: true,
    validate: (reason) => reason.trim().length > 0,
  },
};
